import { useNavigate } from 'react-router-dom';
import { IncidentsTable } from '../components/IncidentsTable';
import { Btn, PageHead } from '../components/ui/primitives';

export function Incidents() {
  const navigate = useNavigate();
  return (
    <>
      <PageHead
        title="Incidents"
        sub="Every Art.14 event and manual case — auto-opened from KEV or created by you."
        action={<Btn variant="primary" onClick={() => navigate('/app/incidents/new')}>＋ New incident</Btn>}
      />
      <IncidentsTable />
    </>
  );
}
